import store from '../store';

export default {
  setBids() {
    return store.dispatch('Data/Auctions/setBids');
  },
  addBids(payload) {
    return store.dispatch('Data/Auctions/addBids', payload);
  },
};
